import { z } from "zod"

export const MessageIdSchema = z.object({
  messageId: z.string().transform(BigInt),
})

export const RateMessageBodySchema = z.object({
  rating: z.enum(["POSITIVE", "NEGATIVE"]),
})

export const GetMessagesQuerySchema = z.object({
  conversationId: z.string().transform(BigInt),
  before: z.string().transform(BigInt).optional(),
  after: z.string().transform(BigInt).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
})

export const GetMessageCapabilityExecutionsQuerySchema = z.object({
  includeRaw: z
    .union([z.boolean(), z.enum(["true", "false"])])
    .transform((value) => (typeof value === "string" ? value === "true" : value))
    .default(false),
})
